import React from 'react';
import { Check } from 'lucide-react';
import { colors, FONT } from '../../../../theme';
import { sheetStyles } from '../../Sheets';

/**
 * Filter and sort as sheets, not as chips across the top.
 *
 * Five chips with counters need about 520px of text on a 390px screen, so they
 * scroll sideways — and that scroll starts at the left edge, exactly where iOS
 * reads a back gesture. One button that opens a list costs one tap and no
 * fight with the system.
 */
function PickSheet({ title, options, value, onPick, onClose }) {
  return (
    <div style={sheetStyles.backdrop} onClick={onClose}>
      <div style={sheetStyles.container} onClick={(e) => e.stopPropagation()}>
        <div style={sheetStyles.handle} />
        <div style={{ fontFamily: FONT, fontSize: 17, fontWeight: 600, color: colors.gray900 }}>
          {title}
        </div>
        {options.map(o => (
          <button key={o.id} onClick={() => { onPick(o.id); onClose(); }}
            style={{
              display: 'flex', alignItems: 'center', gap: 12, width: '100%', minHeight: 52,
              padding: '12px 4px', background: 'none', border: 'none', cursor: 'pointer',
              fontFamily: FONT, textAlign: 'left',
            }}>
            <span style={{ fontSize: 15, color: colors.gray900, flex: 1 }}>
              {o.label}
              {o.count != null && <span style={{ color: colors.gray600 }}> · {o.count}</span>}
            </span>
            {value === o.id && <Check size={18} color={colors.gray900} />}
          </button>
        ))}
        {options.some(o => o.note) && (
          <div style={{ fontFamily: FONT, fontSize: 12.5, color: colors.gray600, lineHeight: 1.4, marginTop: 8 }}>
            {options.find(o => o.note)?.note}
          </div>
        )}
      </div>
    </div>
  );
}

export function AdminFilterSheet({ status, counts = {}, onPick, onClose }) {
  return (
    <PickSheet
      title="Показать" value={status} onPick={onPick} onClose={onClose}
      options={[
        { id: 'all', label: 'Все', count: counts.all },
        { id: 'online', label: 'В сети', count: counts.online },
        // On a fresh server this is the biggest group by far: accounts created
        // by the administrator that nobody has signed into yet.
        { id: 'never', label: 'Не заходили ни разу', count: counts.never },
        { id: 'dormant90', label: 'Спят больше 90 дней', count: counts.dormant90 },
        { id: 'disabled', label: 'Заблокированы', count: counts.disabled },
        { id: 'admins', label: 'Администраторы', count: counts.admins },
      ]}
    />
  );
}

export function AdminSortSheet({ sort, onPick, onClose }) {
  return (
    <PickSheet
      title="Порядок" value={sort} onPick={onPick} onClose={onClose}
      options={[
        { id: 'created_desc', label: 'Сначала новые' },
        { id: 'last_seen_desc', label: 'По последнему входу',
          note: 'По последнему входу порядок может смещаться, пока вы листаете: это время меняется само.' },
        { id: 'name_asc', label: 'По имени' },
      ]}
    />
  );
}
